export const catalogCars = [
  {
    id: 1,
    brand: "Volkswagen",
    model: "Golf GTI",
    year: 2022,
    km: 18000,
    power: "245 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 32500,
    origin: "Alemania",
    badge: "POPULAR",
    image: "https://images.openai.com/static-rsc-4/iUs2ouhmD_f7jECjEJjNGNnKJFoEXFd90TL3xs_IAvOtMFekQDpnm1YHBjOvoSiRAJaJKP2IRCientsftsBc_6XBw1KgyixiVW-IzcW24HhqX4mS6BcJqKsvgEQuVv_br8gN-0tNZQFNSOffGvgNdJ-FmfXsU02GEkD43eMsJ4s?purpose=inline",
  },
  {
    id: 2,
    brand: "Audi",
    model: "A3 Sportback",
    year: 2023,
    km: 14000,
    power: "150 CV",
    fuel: "Gasolina",
    type: "Berlina",
    transmission: "Automático",
    price: 31500,
    origin: "Alemania",
    badge: "NUEVO",
    image: "https://images.openai.com/static-rsc-4/HiNAaaslIHW5dSmwniqYJyB-dhCOIC8ICiW7NKsb9neQeKnE7lgxFJJ1Z5NYhbUcZ0aUXp2yQDPWVbrcYaHcDgWBBHCS3Rg2sVWErnIa4DRJH7Ue7rPOr2VfAa1XwkVANF-AHDPjeyFHcekBar8zLXF8SEzhMAGboW25X4f9fqY?purpose=inline",
  },
  {
    id: 3,
    brand: "Mercedes",
    model: "Clase A 200",
    year: 2022,
    km: 19000,
    power: "163 CV",
    fuel: "Gasolina",
    type: "Berlina",
    transmission: "Automático",
    price: 29800,
    origin: "Países Bajos",
    badge: "IMPORTADO",
    image: "https://images.openai.com/static-rsc-4/BDkXy4UJmRQ1uKuD3jjeO4yyp6rVjrX9XIgz7F7M1JLzI9jYlprgxjD5nnoKnNmWWboaCMDCJVlcgCb0v-kU2gU6QhilgcVLdUpB0Uk3bTftoJgN47Ft-6StWoNHwPHSKf7lZfj5d-ih8xA49OP3uk5bWAIU9LEdUoO_ops1d43L-Fzp6QmWC1DZSa5Vx4Go?purpose=fullsize",
  },
  {
    id: 4,
    brand: "BMW",
    model: "Serie 3 320d",
    year: 2022,
    km: 32000,
    power: "190 CV",
    fuel: "Diésel",
    type: "Berlina",
    transmission: "Automático",
    price: 39500,
    origin: "Países Bajos",
    badge: "IMPORTADO",
    image: "https://images.openai.com/static-rsc-4/VaarMobp5Os3mA1nYSyUMSbJmN7Ph7-X2XUT4bXAOs1Eak4FAGsOo6dXleuPU1THw3NYDye0mlK0HDTeSWFiOG0YQFZzyYvVze82PE0k1MbItkzncVfWDHHoZtV-DFLdPWWluPvjgjkQvFF768PJHtCwwQGtmegRcgBuVA9qbas?purpose=inline",
  },
  {
    id: 5,
    brand: "Audi",
    model: "A5 Sportback",
    year: 2023,
    km: 17000,
    power: "204 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 47900,
    origin: "Alemania",
    badge: "PREMIUM",
    image: "https://images.openai.com/static-rsc-4/Ub-3Xn7kbzCUFzBC_Dcb5X_-RYEaTQGo4FqeI13iPFx7jTNVA6a1argYrvYl9ESJ0C5PAjuN7p77sG2fPS1u_jKJj7ntlxFBDXTopw4fgY9FGw41U1kRqdP_yIw8cRHTixTpZKUSYL7y_Wy0FDxGT3b6JekQh5PwGMiYVI9J9Eg?purpose=inline",
  },
  {
    id: 6,
    brand: "Mercedes",
    model: "Clase C 300",
    year: 2023,
    km: 11000,
    power: "258 CV",
    fuel: "Híbrido",
    type: "Berlina",
    transmission: "Automático",
    price: 54500,
    origin: "Alemania",
    badge: "NUEVO",
    image: "https://images.openai.com/static-rsc-4/QIcopFBanqVTIr_840DyvCA2ZQuUmqeqJZWJc9FVFJdMOv8lSgpBSUBALxuZFAg5liuJbqJZ4TnixA8vjaR1QR2SUwfr-6AXFLH4r5oQPFUJtB04N4E-DzygeB4FbN6uNB2FJYN7G3uL80NBCGWGBoCSrUCDdtObBM5_QQmG5bMyekdp_uqn-dykkEjkIixG?purpose=fullsize",
  },
  {
    id: 7,
    brand: "BMW",
    model: "M2",
    year: 2023,
    km: 8000,
    power: "460 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Manual",
    price: 68900,
    origin: "Alemania",
    badge: "EXCLUSIVO",
    image: "https://images.openai.com/static-rsc-4/ztJS5HX4im-gWPG3vof_UZAdYSDIH0IZjGDBZyvnEfe2N5wYOrTyf1HPWV7o87AX1P9HKLVwHJWTBtMYCF5kiSU7eBLdAiG_znn2mO3zmC0FVdQiTAf6PQ44BGFKlZ31QGl5mBo9JVeLeSPlEmRp5uml71q6OxlGn1-2tWa_QRhh9AfZ1nL0gnZa9MiqOc3M?purpose=fullsize",
  },
  {
    id: 8,
    brand: "Audi",
    model: "RS3 Sportback",
    year: 2022,
    km: 20000,
    power: "400 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 63500,
    origin: "Bélgica",
    badge: "EXCLUSIVO",
    image: "https://images.openai.com/static-rsc-4/cio-xw2HJIfTmMN62ttY-Q9_JZ8C_WMczfXLP1gp6G11SJRKIYRKMW9t7U_bLYko6BTDzgaWca1KeEWSJAXt6cXZM1Vv4Z0TceJvP6tE9GzQYId4fc0IehrObjjw01vN_7pO0oQPQS7sH1jbF2YKtUwmIeJBZMcYPCQhxYcPmcs?purpose=inline",
  },
  {
    id: 9,
    brand: "Mercedes",
    model: "AMG A45 S",
    year: 2022,
    km: 15000,
    power: "421 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 71900,
    origin: "Alemania",
    badge: "AMG",
    image: "https://images.openai.com/static-rsc-4/yNQaKdZRYwFKXLibF7YkVn0MaPu2VcfUrTn02DZd8FIuQgD_RFrdck4kHH6hHsLgq3yWec1QDd6x6ZCDKwTsoXvItEtLmFhLCgrwu1B88ZTFdhKdEBYBKOzsaqxSxoaJuZ99t6SIQM3X38mMEB0i_QzQ-XX9cqlAWh2zN5SZAvb0sM4-NUOsbHu3LkrQuENU?purpose=fullsize",
  },
  {
    id: 10,
    brand: "BMW",
    model: "M4 Competition",
    year: 2023,
    km: 11000,
    power: "510 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 82500,
    origin: "Alemania",
    badge: "TOP",
    image: "https://images.openai.com/static-rsc-4/W1s0NBm-iTNwlZZceZKsvoXBymYDZW-wlvjEtwIWgJHVhUTV-0VanM2iv6OMZ5-axWqrFF6mkPc8ftqD5JxOiiC6t_M5xpp03nRwXsVF5PwAp7ZBnwpcbOYaXSRDntB_HuMX_UBx7fRdstaRsDB354MuaU0nSebpwcPeACMJe8M?purpose=inline",
  },
  {
    id: 11,
    brand: "Porsche",
    model: "Cayenne",
    year: 2022,
    km: 24000,
    power: "340 CV",
    fuel: "Gasolina",
    type: "SUV",
    transmission: "Automático",
    price: 94500,
    origin: "Alemania",
    badge: "PREMIUM",
    image: "https://images.openai.com/static-rsc-4/_8PeMGv_Ie7APyWxnvcvd4jwXCK0XezftTsC2ISfhgZwgO92sfqJl3VWUY80bryQhgU7kE1dDWqX_SRtjnemJQPy38s1XG_ANymmuBkxkX_fXy-kXhQKw2B5NezV82PNfD3SgfbKMR_7XdvIQls6G55P2FkY1PTzB5N-WXrQJKE?purpose=inline",
  },
  {
    id: 12,
    brand: "Porsche",
    model: "911 Carrera 4S",
    year: 2023,
    km: 5000,
    power: "450 CV",
    fuel: "Gasolina",
    type: "Deportivo",
    transmission: "Automático",
    price: 156900,
    origin: "Alemania",
    badge: "EXCLUSIVO",
    image: "https://images.openai.com/static-rsc-4/LlKoxMVbGIUBw14qwoycmUYu7xNkewCQO3YlMA81S8cU4gQkGypRpIfiua9F3mKjiEgLFHZkyCFbPuUVPWLV8yOxii7fCl0b2mw8c8EKB8Bq66CBlajvWiyj5LTwIgUXbsCHL5mM7xwx1HRsrzOI83DP9QcaGNV2U0W0pNZ9W3w?purpose=inline",
  },
];

export const featuredCars = [
  {
    id: 1,
    brand: "BMW",
    model: "M4 Competition",
    year: 2023,
    speed: "290 km/h",
    power: "510 CV",
    origin: "Alemania",
    acceleration: "3.9s",
    image: "https://images.openai.com/static-rsc-4/W1s0NBm-iTNwlZZceZKsvoXBymYDZW-wlvjEtwIWgJHVhUTV-0VanM2iv6OMZ5-axWqrFF6mkPc8ftqD5JxOiiC6t_M5xpp03nRwXsVF5PwAp7ZBnwpcbOYaXSRDntB_HuMX_UBx7fRdstaRsDB354MuaU0nSebpwcPeACMJe8M?purpose=inline",
  },
  {
    id: 2,
    brand: "Mercedes",
    model: "C63 AMG",
    year: 2023,
    speed: "280 km/h",
    power: "476 CV",
    origin: "Alemania",
    acceleration: "3.4s",
    image: "https://readdy.ai/api/search-image?query=Mercedes%20AMG%20C63%202023%20obsidian%20black%20metallic%20inside%20grand%20Mercedes%20AMG%20showroom%20with%20high%20vaulted%20ceiling%2C%20dramatic%20accent%20spotlights%20highlighting%20muscular%20bodywork%20contours%2C%20highly%20polished%20dark%20floor%20with%20vivid%20reflection%2C%20AMG%20Performance%20sign%20on%20elegant%20back%20wall%2C%20ultra%20wide%20dealership%20real%20photograph%20authentic%20car%20no%20CGI%2C%20powerful%20three%20quarter%20front%20angle%20showing%20aggressive%20AMG%20front%20apron%20and%20wide%20stance&width=1400&height=800&seq=mercc63_hero_dealer_showcase&orientation=landscape",
  },
  {
    id: 3,
    brand: "Audi",
    model: "RS6 Avant",
    year: 2023,
    speed: "305 km/h",
    power: "600 CV",
    origin: "Alemania",
    acceleration: "3.6s",
    image: "https://readdy.ai/api/search-image?query=Audi%20RS6%20Avant%202023%20sebring%20black%20crystal%20metallic%20performance%20estate%20wagon%20inside%20flagship%20Audi%20showroom%2C%20wide%20interior%20with%20high%20ceilings%2C%20bright%20professional%20showroom%20lighting%20overhead%2C%20four%20rings%20Audi%20logo%20on%20brushed%20metal%20wall%2C%20highly%20polished%20floor%20showing%20full%20car%20reflection%2C%20ultra%20wide%20interior%20dealership%20real%20photograph%20authentic%20car%20no%20CGI%2C%20dramatic%20three%20quarter%20front%20angle%20showing%20massive%20air%20intakes%20and%20RS%20badging%20with%2022%20inch%20wheels&width=1400&height=800&seq=audirs6_hero_dealer_showcase&orientation=landscape",
  },
  {
    id: 4,
    brand: "Porsche",
    model: "911 Carrera 4S",
    year: 2023,
    speed: "306 km/h",
    power: "450 CV",
    origin: "Alemania",
    acceleration: "3.4s",
    image: "https://images.openai.com/static-rsc-4/LlKoxMVbGIUBw14qwoycmUYu7xNkewCQO3YlMA81S8cU4gQkGypRpIfiua9F3mKjiEgLFHZkyCFbPuUVPWLV8yOxii7fCl0b2mw8c8EKB8Bq66CBlajvWiyj5LTwIgUXbsCHL5mM7xwx1HRsrzOI83DP9QcaGNV2U0W0pNZ9W3w?purpose=inline",
  },
];